import React from "react";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { initFullStory } from "utilities/full-story";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "./index.scss";
import { initNewRelic } from "new-relic/new-relic";

//For dynamic config variables importing - making globalThis variable typesafe to access env key
//we access globalThis.env in runtime so to avoid typechecking, declaring key globally
declare global {
  export interface EnvironmentVariable {
    ENVIRONMENT?: string;
    REACT_APP_BASE_BFF_WEB_URL: string;
    APPLICATION_ID: string;
    ENABLE_FULL_STORY: boolean;
    FULLSTORY_ORG_ID: string;
    DISPLAY_STEP_CODE?: boolean;
    NEW_RELIC_ACCOUNT_ID_AND_TRUST_KEY: string;
    NEW_RELIC_AGENT_ID_AND_APPLICATION_ID: string;
    NEW_RELIC_LICENSE_KEY: string;
    NEW_RELIC_ALLOWED_ORIGINS: string;
    ESIGN_SCRIPT_URL: string;
    ESIGN_DATA_SITE_ID: string;
    TTD_CODE_SNIPPET_URL: string;
    TRANSPERFECT_SCRIPT_URL: string;
    TRANSPERFECT_SCRIPT_DATA_OLJS: string;
    LO_SEARCH_REDIRECT_URL: string;
    MAINTENANCE_BYPASS_KEY?: string;
  }
  // eslint-disable-next-line no-var
  var env: EnvironmentVariable;
  // eslint-disable-next-line no-var
  var optimizely: any;
}

initFullStory();
initNewRelic();
const root = ReactDOM.createRoot(document.getElementById("root")!);
const persistor = persistStore(store);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
